import React from "react";
import { Link } from "react-scroll";
import { useNavigate } from "react-router-dom";
import styles from "./HomeFooter.module.css";
import footerLogo from "../../../assets/images/svg/Footer logo.svg";
import BrandLogo from "../../../components/common/BrandLogo/BrandLogo";
import linkedinIcon from "../../../assets/images/svg/LinkedIn.svg";
import twitterIcon from "../../../assets/images/svg/twitter212.svg";
import ytIcon from "../../../assets/images/svg/Youtube.svg";
import ImgFrame from "../../../components/common/ImageFrame/ImgFrame";
import Soc2img from "../../../assets/images/png/Soc2.png";
import AicpImg from "../../../assets/images/png/AICPA.png";

const legalLinks = [
  { label: "Terms and Conditions", target: "terms_content", path: "/terms" },
  { label: "Privacy Policy", target: "prp_content", path: "/privacy" },
  { label: "Legal Disclaimer", target: "legal_content", path: "/legal" },
  { label: "Cookie Policy", target: "cookie_content", path: "/cookie" },
];

const socialLinks = [
  {
    label: "LinkedIn",
    href: "https://www.linkedin.com/company/bidtoaster/",
    icon: linkedinIcon,
    className: "",
  },
  {
    label: "Twitter",
    href: "https://twitter.com/bidz_ai",
    icon: twitterIcon,
    className: styles.twit,
  },
  {
    label: "Youtube",
    href: "https://youtube.com/watch?v=gWqwdihEBoA&feature=share8",
    icon: ytIcon,
    className: "",
  },
];

const HomeFooter = () => {
  const navigate = useNavigate();

  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.topSection}>
          <div className={styles.logoGroup}>
            <div className={styles.footerLogo}>
              <BrandLogo imgSrc={footerLogo} />
            </div>

            <div className={styles.badgeRow}>
              <img src={Soc2img} alt="SOC 2 Compliant" />
              <img src={AicpImg} alt="AICPA Certified" />
            </div>
          </div>

          <div className={styles.bottomSection}>
            <div className={styles.linkSection}>
              <div className={styles.legalHeading}>Legal</div>
              {legalLinks.map((link) => (
                <Link
                  key={link.label}
                  to={link.target}
                  offset={-120}
                  duration={500}
                  onClick={() => navigate(link.path)}
                  className={styles.link}
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>
        </div>

        <div className={styles.footerBottom}>
          <div className={styles.socialMedia}>
            {socialLinks.map((item) => (
              <a
                key={item.label}
                href={item.href}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.icon}
              >
                <ImgFrame
                  imgSrc={item.icon}
                  customClass={`${styles.smI} ${item.className}`}
                />
                {item.label}
              </a>
            ))}
          </div>

          <div className={styles.copyright}>
            Copyright (c) 2023 bidz.ai. All Rights Reserved.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default HomeFooter;
